module.exports = __webpack_public_path__ + "img/switzerland-congenital-and-perinatal-diseases-female.cdd39eed.png";